/**
 * Marketing-friendly event names for actions to be used for tracking purposes
 */
import {
  SET_SESSION_SUCCESS,
  LOG_OUT_REQUESTED,
  CREATE_ORG_SUCCESS,
  CREATE_EMAIL_VERIFICATION_SUCCESS,
  UPDATE_ORG_SUCCESS,
  CREATE_STRIPE_SOURCE_SUCCESS,
  UPDATE_STRIPE_SOURCE_SUCCESS,
  CREATEINSTANCE_REQUESTED,
  CREATEINSTANCE_FAILURE,
  CREATE_TOKEN_SUCCESS,
  DELETE_TOKEN_SUCCESS,
  CREATE_USERINVITE_SUCCESS,
  ACCEPT_INVITATION_SUCCESS,
} from '../../dux/actions';

const map = {
  [SET_SESSION_SUCCESS]: {
    eventName: 'Account Logged In',
    eventCatagory: 'Account',
  },
  [LOG_OUT_REQUESTED]: {
    eventName: 'Account Logged Out',
    eventCatagory: 'Account',
  },
  [CREATE_EMAIL_VERIFICATION_SUCCESS]: {
    eventName: 'Verification Email Resent',
    eventCatagory: 'Account',
  },
  // Organization
  [CREATE_ORG_SUCCESS]: {
    eventName: 'Organization Created',
    eventCatagory: 'Organization',
  },
  [UPDATE_ORG_SUCCESS]: {
    eventName: 'Organization Updated',
    eventCatagory: 'Organization',
  },
  [CREATE_STRIPE_SOURCE_SUCCESS]: {
    eventName: 'Credit Card Added',
    eventCatagory: 'Organization',
  },
  [UPDATE_STRIPE_SOURCE_SUCCESS]: {
    eventName: 'Credit Card Updated',
    eventCatagory: 'Organization',
  },
  // Create Instance
  [CREATEINSTANCE_REQUESTED]: {
    eventName: 'Instance Creation Requested',
    eventCatagory: 'Instance Create',
  },
  [CREATEINSTANCE_FAILURE]: {
    eventName: 'Instance Creation Failed',
    eventCatagory: 'Instance Create',
  },

  // API Token
  [CREATE_TOKEN_SUCCESS]: {
    eventName: 'API Token Created',
    eventCatagory: 'API Token',
  },
  [DELETE_TOKEN_SUCCESS]: {
    eventName: 'API Token Deleted',
    eventCatagory: 'API Token',
  },
  // User Invite
  [CREATE_USERINVITE_SUCCESS]: {
    eventName: 'User Invited',
    eventCatagory: 'User Management',
  },
  [ACCEPT_INVITATION_SUCCESS]: {
    eventName: 'User Invite Accepted',
    eventCatagory: 'User Management',
  },
};

export default map;
